/**
 * Created by mohit.chavda on 2/27/2017.
 */
export class ApplicationItem{
  loginId:number;
  applicationId:number;
  applicationStartDate:Date;
  isActive:boolean;
  programId:number;
  applicationStatus:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/ApplicationItem.ts